










import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import EdrLeftNav from "../../components/left-nav.vue";
import SizhenPatients from "./sizhen-patients/sizhen-patients.vue";
@Component({
  components: {
    MainHeader,
    EdrLeftNav,
    SizhenPatients
  }
})
export default class EdrPatientList extends Vue {
  private projectName: any = "名医传承数据中心";
  private changeProjectName(name) {
    this.projectName = name;
  }
}
